import { createSelector } from 'reselect'

import { WidgetName } from '../configs'

import { selectWidgets } from './selectWidgets'

export const selectWidget = (name: WidgetName) =>
  createSelector(selectWidgets, (widgets) => widgets[name])
